var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIconWhiteOnGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.395 4.213a.727.727 0 0 1 1.028 0l3.637 3.636a.727.727 0 0 1 0 1.029l-3.637 3.636a.727.727 0 0 1-1.028-1.028L16.79 9.09H4.727a.727.727 0 0 1 0-1.455H16.79l-2.395-2.394a.727.727 0 0 1 0-1.029zm-4.79 7.273a.727.727 0 0 1 0 1.028L7.21 14.91h12.063a.727.727 0 1 1 0 1.455H7.21l2.395 2.395a.727.727 0 1 1-1.028 1.028L4.94 16.151a.727.727 0 0 1 0-1.029l3.637-3.636a.727.727 0 0 1 1.028 0z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconWhiteOnGrey);
export default __webpack_public_path__ + "static/media/Mail-Icon-White-on-Grey.b11e73b1d14861711023c6b821194c87.svg";
export { ForwardRef as ReactComponent };